import React, { useState } from "react";
import { FileDown } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { eaParams, useEa } from "./EaContext";
import { useSelectedCodes } from "./EaControls";

const LEVELS = [["summary", "Sintesi per sezione", "KPI, grafico mensile e tabella principale di Overview, Forecast vs Budget, Power, Gas e KPI & Sostenibilità."],
  ["detail", "Completo con dettaglio per punto", "Aggiunge dettaglio per POD/PDR, confronti anno su anno, copertura fixing, mix energetico e fattori di emissione."]];

export function EaFullReport({ collapsed }) {
  const { filters } = useEa();
  const codes = useSelectedCodes();
  const [open, setOpen] = useState(false);
  const [level, setLevel] = useState("summary");
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const r = await api.get("/ea/full-report.pdf", { params: eaParams(filters, { codes, level }), responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      Object.assign(document.createElement("a"), { href: url, download: `Report_Completo_EA_${filters.year || ""}.pdf` }).click();
      URL.revokeObjectURL(url);
      setOpen(false);
    } catch { toast.error("Report non disponibile"); }
    setBusy(false);
  };
  return (
    <div className="px-3 pb-4 pt-2 border-t border-white/10">
      <button onClick={() => setOpen(true)} title="Scarica Report Completo" data-testid="ea-full-report-open"
        className={`w-full h-10 rounded-lg bg-white text-[#071B4D] text-sm font-bold inline-flex items-center gap-2 hover:bg-blue-50 transition-colors ${collapsed ? "justify-center" : "px-3"}`}>
        <FileDown size={17} className="shrink-0" />{!collapsed && "Scarica Report Completo"}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="ea-full-report-dialog">
          <DialogHeader><DialogTitle>Scarica Report Completo</DialogTitle></DialogHeader>
          <div className="text-sm text-slate-500">Anno {filters.year}{codes ? ` · ${codes.split(",").length} ${codes.split(",").length === 1 ? "punto selezionato" : "punti selezionati"}` : " · tutti i punti"}. Scegli il livello di completezza:</div>
          <div className="space-y-2">
            {LEVELS.map(([k, l, d]) => (
              <label key={k} className={`flex gap-3 rounded-lg border p-3 cursor-pointer ${level === k ? "border-blue-600 bg-blue-50" : "border-slate-200"}`} data-testid={`ea-full-report-level-${k}`}>
                <input type="radio" checked={level === k} onChange={() => setLevel(k)} className="mt-1" />
                <span><span className="block font-semibold text-slate-900">{l}</span><span className="block text-xs text-slate-500">{d}</span></span>
              </label>
            ))}
          </div>
          <button onClick={download} disabled={busy} className="h-10 rounded-lg bg-slate-900 text-white text-sm font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-60" data-testid="ea-full-report-download">
            <FileDown size={16} /> {busy ? "Generazione in corso…" : "Scarica PDF"}
          </button>
        </DialogContent>
      </Dialog>
    </div>
  );
}
